var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 175,
    viewBox: "0 0 83 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 0.906647H1.54002C0.965407 0.906647 0.5 1.37205 0.5 1.94666V134C0.5 156.644 18.8563 175 41.5 175C64.1437 175 82.5 156.644 82.5 134V41.9066C82.5 19.2629 64.1437 0.906647 41.5 0.906647ZM15.4814 18.0045C15.4814 16.8553 16.4122 15.9245 17.5615 15.9245H41.5C55.8704 15.9245 67.5186 27.5726 67.5186 41.943C67.5186 56.3135 55.8704 67.9616 41.5 67.9616H17.5615C16.4122 67.9616 15.4814 67.0308 15.4814 65.8816V18.0045ZM67.5212 84.9295V91.0214C67.5212 92.1706 66.5904 93.1014 65.4412 93.1014H17.5615C16.4122 93.1014 15.4814 92.1706 15.4814 91.0214V84.9295C15.4814 83.7803 16.4122 82.8494 17.5615 82.8494H65.4412C66.5904 82.8494 67.5212 83.7803 67.5212 84.9295ZM41.5026 161.267C26.425 161.267 14.2022 149.044 14.2022 133.966C14.2022 118.889 26.425 106.666 41.5026 106.666C56.5802 106.666 68.803 118.889 68.803 133.966C68.803 149.044 56.5802 161.267 41.5026 161.267Z",
    fill: "#3366ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6746 57.8085H41.2452C49.8461 57.8085 57.238 50.778 57.3628 42.177C57.4902 33.3213 50.3245 26.0776 41.5 26.0776H26.6746C26.1 26.0776 25.6346 26.543 25.6346 27.1176V56.7685C25.6346 57.3431 26.1 57.8085 26.6746 57.8085Z",
    fill: "#3366ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 150.609C50.6083 150.609 57.9921 143.157 57.9921 133.964C57.9921 124.771 50.6083 117.318 41.5 117.318C32.3917 117.318 25.008 124.771 25.008 133.964C25.008 143.157 32.3917 150.609 41.5 150.609Z",
    fill: "#3366ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLogo);
export default __webpack_public_path__ + "static/media/blue-logo.ddb42b4c5d3b0727db965471741241dc.svg";
export { ForwardRef as ReactComponent };